<template>
  <div class="home-category" @mouseleave="categoryId = null">
    <Transition name="fade">
      <ul v-if="menulist.length" class="menu">
        <li
          v-for="item in menulist"
          :key="item.chID"
          :class="{ active: categoryId && categoryId === item.chID }"
          @mouseenter="categoryId = item.chID"
        >
          <i class="iconfont" :class="item.icon"></i>
          <RouterLink to="/">{{ item.chName }}</RouterLink>
          <i
            style="float: right; margin-right: 15px"
            class="iconfont icon-chevron-right"
          ></i>
        </li>
      </ul>
      <CateSkeleton v-else />
    </Transition>
    <!-- 弹层 -->
    <div class="layer">
      <div v-if="currCategory">
        <ul class="sub-category" v-for="sub in currCategory" :key="sub.index">
          <li>{{ sub.coName }}</li>
          <div class="thr-category" v-for="thr in sub.children" :key="thr.clID">
            <RouterLink
              target="_blank"
              :to="`video?firstCate=${categoryId}&secondCate=${sub.coID}&thirdCate=${thr.clID}`"
              >{{ thr.clName }}</RouterLink
            >
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CateSkeleton from "./cate-skeleton.vue";
import { useStore } from "vuex";
import { computed, ref } from "vue";

//import { findCategory } from "@/api/home";
export default {
  name: "HomeCategory",
  components: {
    CateSkeleton,
  },
  setup() {
    const store = useStore();

    const menulist = computed(() => {
      let list = store.state.category.list.filter((items) => items.pid === 0);
      return list;
    });

    const sublist = computed(() => {
      let list = store.state.category.list.filter((items) => items.pid === 1);
      let sumlist = list.map((item) => {
        return {
          chID: item.chID,
          caID: item.caID,
          coID: item.coID,
          coName: item.coName,
          id: item.id,
          pid: item.pid,
          children: [],
        };
      });

      const arrlist = store.state.category.list.filter(
        (item) => item.pid === 2
      );
      const catelist = arrlist.forEach((item, i) => {
        try {
          list.forEach((vtem, index) => {
            if (vtem.coID === item.cbID) {
              sumlist[index].children.push(item);
            }
          });
        } catch (error) {
          console.log(error);
        }
      });
      return sumlist;
    });
    const categoryId = ref(null);
    const currCategory = computed(() => {
      let list = sublist.value.filter((item) => item.caID === categoryId.value);
      return list.sort((a, b) => {
        return a.coID - b.coID;
      });
    });

    return { menulist, currCategory, categoryId };
  },
};
</script>

<style scoped lang="less">
.home-category {
  width: 250px;
  height: 500px;
  background: rgba(0, 0, 0, 0.8);
  position: relative;
  z-index: 99;
  border-radius: 5px;
  .menu {
    li {
      padding-left: 20px;
      height: 50px;
      line-height: 50px;
      border-radius: 5px;
      cursor: pointer;
      list-style: none;
      &:hover,
      &.active {
        background: @shColor;
      }
      a {
        font-size: 16px;
        color: rgb(255, 255, 255);
      }
      i {
        color: #fff;
        font-size: 20px;
        margin-right: 25px;
      }
    }
  }
  .layer {
    width: 650px;
    height: 500px;
    background: rgba(250, 249, 249, 0.9);
    position: absolute;
    left: 250px;
    top: 0;
    display: none;
    padding: 0 15px;
    overflow: auto;
    border-radius: 8px;
    .sub-category {
      font-size: 20px;
      color: @shColor;
    }
    .thr-category {
      font-size: 16px;
      padding: 10px 15px;
      display: inline-block;
      a {
        &:hover {
          padding-bottom: 8px;
          color: @shColor;
          border-bottom: 1px solid @shColor;
        }
      }
    }
  }
  &:hover {
    .layer {
      display: block;
    }
  }
}
</style>
